import { Item, ItemConditionTypeEnum } from '@conveyr/shared-types';
import { AxiosInstance } from 'axios';
import type { operations } from '@/api/generated/openapi';
import { axiosWithoutCaseMiddleware } from '@/helpers/forms/axios';
import { toItem, WithInventoryItems } from './index';

export type SearchInventoryResponse = WithInventoryItems<operations['search-inventory']['responses']['200']['content']['application/json']>;
export type SearchInventoryRequest = operations['search-inventory']['requestBody']['content']['application/json'];

interface inventorySearchFilters {
    condition_type: ItemConditionTypeEnum
}

export default (axios: AxiosInstance = axiosWithoutCaseMiddleware): { searchInventory: (query: string, abortSignal: AbortSignal) => Promise<Item[]>; searchInventoryByTitleSimilarity: (title: string, filters?: inventorySearchFilters) => Promise<Item[]>; } => ({
    searchInventory: async (query: string, abortSignal: AbortSignal): Promise<Item[]> => {
        const body: SearchInventoryRequest = { q: query };
        const response = await axios.post<SearchInventoryResponse>('/api/inventory/search', body, {
            signal: abortSignal,
        });
        return response.data.items.map(inv => toItem(inv));
    },

    searchInventoryByTitleSimilarity: async (title: string, filters?: inventorySearchFilters): Promise<Item[]> => {
        const body: SearchInventoryRequest = {
            q: title,
            mode: 'title_similarity',
            filters,
        };
        const response = await axios.post<SearchInventoryResponse>('/api/inventory/search', body);
        return response.data.items.map(inv => toItem(inv));
    },
});
